module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_17.70bac389.png";